import React, { useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import sucessimg from "../../Assets/Images/successtripe.png"
import img from "../../Assets/Images/login_logo.png"
function Stripe() {

  return (
     
 
      
    <>
      <section className="login-pg">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 p-0">
              <div className="login-lft-sec">
                <img src={img} className="img-fluid  mb-3" alt="" />
                <div className="login-img-txt">
                  <h3>Streamline Your Business Invoicing Effortlessly</h3>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="card-body">
                <div className="row">
                  <div className="col-12 col-sm-10 col-md-7 col-lg-9 col-xxl-8 mx-auto">
                    <div class="text-center">
                      <img class="img-fluid" src={sucessimg} />
                      <h3 class="mt-4">Success!</h3>
                      <h6 class="gray mb-4">Your account is now connected</h6>
                      <Link to="/dashboard" class="btn btn-primary w-100" data-bs-dismiss="modal">Get Started</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Stripe